module.exports = __webpack_public_path__ + "static/media/whatsup.d39af38d.svg";